import React, { useEffect } from "react";

const Disclaimer = () => {

  // ✅ SEO
  useEffect(() => {
    document.title = "Disclaimer | JobKickstart";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "Read the disclaimer of JobKickstart regarding job listings, external links, and information accuracy.";
    document.head.appendChild(meta);
  }, []);

  return (
    <div style={styles.wrapper}>
      <h1 style={styles.title}>Disclaimer</h1>

      <p style={styles.text}>
        The information provided on <strong>JobKickstart</strong> is for general
        informational purposes only. While we strive to keep the information
        accurate and up to date, we make no warranties or guarantees regarding
        the completeness, reliability, or accuracy of this information.
      </p>

      <h2 style={styles.heading}>Job Information</h2>
      <p style={styles.text}>
        Job listings shared on this platform are collected from various sources.
        We do not guarantee job availability, salary accuracy, or hiring status.
        Users are strongly advised to verify details directly from the official
        company website before applying.
      </p>

      <h2 style={styles.heading}>External Links</h2>
      <p style={styles.text}>
        Our website may contain links to external websites. We do not have
        control over the content and nature of those sites and are not
        responsible for any losses or damages that may occur from using them.
      </p>

      <h2 style={styles.heading}>Professional Advice</h2>
      <p style={styles.text}>
        The content on this website is not intended to be professional or career
        advice. Always seek appropriate guidance before making career decisions.
      </p>

      {/* ✅ NEW TRUST SECTION */}
      <h2 style={styles.heading}>No Fees</h2>
      <p style={styles.text}>
        JobKickstart does not charge any fees for job listings, applications, or
        any services. Users should be cautious of third parties asking for
        payments.
      </p>

      <h2 style={styles.heading}>Use at Your Own Risk</h2>
      <p style={styles.text}>
        Any action you take based on the information on this website is strictly
        at your own risk. JobKickstart will not be liable for any losses or
        damages.
      </p>

      <h2 style={styles.heading}>Consent</h2>
      <p style={styles.text}>
        By using our website, you hereby consent to our disclaimer and agree to
        its terms.
      </p>

      <h2 style={styles.heading}>Contact</h2>
      <p style={styles.text}>
        If you have any questions, contact us at:
        <br />
        📩{" "}
        <a href="mailto:jobkickstart.online@gmail.com">
          jobkickstart.online@gmail.com
        </a>
      </p>
    </div>
  );
};

const styles = {
  wrapper: {
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "auto",
    marginTop: "50px",
    fontFamily: "Arial",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "36px",
    fontWeight: "800",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "22px",
    marginTop: "25px",
    fontWeight: "700",
  },
  text: {
    fontSize: "16px",
    color: "#444",
  },
};

export default Disclaimer;